module.exports = __webpack_public_path__ + "img/ysm-logo.63248150.png";